module.exports = __webpack_public_path__ + "static/media/junior-primo.0ca149e4.png";